import type { ReactNode } from "react";

interface BannerProps {
  image: string;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function Banner({ image, title, subtitle, actionLabel = "View", onAction, className = "" }: BannerProps) {
  return (
    <div className={`relative overflow-hidden rounded-ios-xl ${className}`}>
      <img src={image} alt={title} className="h-64 w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <h2 className="text-2xl font-bold text-white">{title}</h2>
        {subtitle && <p className="text-sm text-white/80 mt-1">{subtitle}</p>}
        {actionLabel && (
          <button
            onClick={onAction}
            className="mt-3 rounded-ios-xl bg-white/20 backdrop-blur-sm px-5 py-2 text-sm font-semibold text-white active:scale-95 transition"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}
